import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Set Cesium ion access token
import { Ion } from 'cesium';
Ion.defaultAccessToken = import.meta.env.VITE_CESIUM_ION_TOKEN || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5ZGM4ZDgzZC00ZTA3LTQ1OTQtYWQzYi0wOGYyMjc0YTdjNzEiLCJpZCI6Mzg1NDI1LCJpYXQiOjE3Njk4MzI0NDB9.NuFe1zaBEu3jsm9FgZTRWRJDVDZiA0vHHWUseDP8QXQ';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
